<div class="container page">
    <div class="pige-express-card">
        <!-- Download section -->
        <div *ngIf="exportFile" class="download-section">
            <div *ngFor="let exportFile of exportArrayFiles">
                <a *ngIf="exportFileUP" [href]="exportFile">
                    <button mat-button class="btn btn-secondaryWithBorder shadow-none">
                        <mat-icon>download</mat-icon> Download
                    </button>
                </a>
            </div>
        </div>

        <!-- Main content -->
        <div class="content-section">
            <div class="title-card">
                <mat-label class="title">🤗 Pige Express 🚀</mat-label>
            </div>
            
            <div class="input-row">
                <!-- Upload section -->
                <div class="upload-section">
                    <mat-label class="labelFont">Upload Pictures</mat-label>
                    <mat-form-field appearance="outline" class="w-100 file-input-custom">
                        <ngx-mat-file-input [multiple]="true" [autofilled]="false" (change)="modifPicture($event)" class="hide-file-names"></ngx-mat-file-input>
                        <mat-icon matSuffix>attach_file</mat-icon>
                    </mat-form-field>
                </div>
                
                <!-- Slide name section -->
                <div class="name-section" [formGroup]="pigeExtern">
                    <mat-label class="labelFont">Name of Slide</mat-label>
                    <mat-form-field appearance="outline" class="w-100">
                        <input matInput placeholder="Enter slide name" formControlName="slideName">
                    </mat-form-field>
                </div>
            </div>
            
            <!-- Loading indicator -->
            <div *ngIf="isUploading" class="loading-container">
                <mat-progress-spinner mode="indeterminate" diameter="40" color="primary"></mat-progress-spinner>
                <span class="loading-text">Uploading images...</span>
            </div>

            <!-- Simple image grid -->
            <div class="image-grid-container">
                <div class="image-grid">
                    <div *ngFor="let item of picPige.content; let i = index" class="image-box">
                        <img [src]="'/api/picture/Images/' + item.picture" alt="Image" class="preview-image">
                        <button type="button" class="delete-btn" (click)="deleteImgForModif(item.picture, item)">×</button>
                    </div>
                </div>
                
                <div *ngIf="picPige.content.length === 0" class="empty-state">
                    <p>Upload images to create your presentation</p>
                </div>
            </div>

            <!-- Action button -->
            <div *ngIf="picPige.content.length > 0" class="action-container">
                <button mat-raised-button class="btn btn-secondary shadow-none" (click)="generateExpress()" [disabled]="loading">
                    <span *ngIf="!loading">Create Pige PPTX</span>
                    <mat-progress-spinner *ngIf="loading" mode="indeterminate" diameter="24" color="accent"></mat-progress-spinner>
                </button>
            </div>
        </div>
    </div>
</div>